import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Upload,
  Typography,
  Spin,
  DatePicker,
  Select,
  Checkbox,
  Alert,
} from "antd";
import { storage } from "firebase";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import { Editor } from "react-draft-wysiwyg";
import { isEmpty } from "lodash";

const { Title } = Typography;
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const buttonItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 4,
  },
};

const LatestArticleForm = ({
  onSubmit,
  onCancelEditMode,
  onFileUpload,
  onChange,
  title,
  descriptionEditor,
  affiliateLink,
  applyedFilters,
  tags,
  date,
  zone,
  file,
  loading,
  editMode,
  description_editor,
  articleCountes,
}) => {
  const onEditorStateChange = (editorState) => {
    onChange(editorState, "description_editor");
  };

  const uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      var uploadTask = storage().ref(`/editor_images/${new Date()}`).put(file);

      uploadTask.on(
        "state_changed",
        function (snapshot) {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        function (error) {
          reject(error);
        },
        function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            const descriptionImagesUrl = JSON.parse(
              localStorage.getItem("descriptionImagesUrl")
            );
            if (!isEmpty(descriptionImagesUrl)) {
              descriptionImagesUrl.push(downloadURL);
              localStorage.setItem(
                "descriptionImagesUrl",
                JSON.stringify(descriptionImagesUrl)
              );
            } else {
              localStorage.setItem(
                "descriptionImagesUrl",
                JSON.stringify([downloadURL])
              );
            }

            console.log("File available at", downloadURL);
            resolve({ data: { link: downloadURL } });
          });
        }
      );
    });
  };

  const toolbar = {
    fontFamily: {
      options: [
        "Arial",
        "Georgia",
        "Impact",
        "Tahoma",
        "Times New Roman",
        "Verdana",
        "Open Sans",
      ],
    },
    inline: {
      inDropdown: false,
    },
    list: { inDropdown: true },
    textAlign: { inDropdown: true },
    link: { inDropdown: true },
    history: { inDropdown: true },
    emoji: { inDropdown: false },
    image: {
      uploadCallback: uploadImageCallBack,
      previewImage: true,
      alt: { present: true, mandatory: false },
      inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
    },
  };

  return (
    <Spin spinning={loading}>
      {articleCountes === 5 && (
        <Alert
          message="Hello Admin, You can not add more Article because you've already added 5 articles, If you want to add then please remove all articles!!!"
          type="info"
          showIcon
        />
      )}
      <Form {...formItemLayout}>
        <Title level={3} style={{ marginLeft: "10%" }}>
          {editMode ? "Update" : "Add"} Latest Article
        </Title>
        <Form.Item label="Title">
          <Input
            onChange={({ target }) => onChange(target.value, "title")}
            value={title}
            placeholder="Enter Article Title"
          /> 
        </Form.Item>
        <Form.Item label="Description">
          <Editor
            editorState={description_editor}
            editorClassName="editorClassName"
            toolbarClassName="toolbar-class"
            wrapperClassName="wrapperClassName"
            wrapperStyle={{
              minHeight: 500,
            }}
            editorStyle={{
              minHeight: 376,
              border: "1px solid #F1F1F1",
              padding: 5,
              borderRadius: 2,
              height: "auto",
            }}
            toolbar={toolbar}
            onEditorStateChange={onEditorStateChange}
          />
        </Form.Item>
        <Form.Item label="Tags-comma separate">
          <Input
            onChange={({ target }) => onChange(target.value, "tags")}
            value={tags && tags.toString()}
            placeholder="tag1,tag2,tag3"
          />
        </Form.Item>
        <Form.Item label="Date">
          <DatePicker
            onChange={(date) => onChange(date.toDate().getTime(), "date")}
            value={date && moment(date)}
          />
        </Form.Item>
        <Form.Item label="Time Zone">
          <Select
            onChange={(e) => {
              onChange(e, "zone");
            }}
            value={zone}
          >
            <Option value="America/New_York">EST</Option>
            <Option value="America/Los_Angeles">PST</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Affiliate Link">
          <Input
            onChange={({ target }) => onChange(target.value, "affiliate")}
            value={affiliateLink}
            placeholder="Enter Affiliate Link"
          />
        </Form.Item>
        <Form.Item label="Filters">
          <Checkbox disabled checked>
            {" "}
            Latest{" "}
          </Checkbox>
        </Form.Item>
        <Form.Item
          name="upload"
          label="Article Image"
          valuePropName="fileList"
          getValueFromEvent={onFileUpload}
        >
          <Upload
            accept="image/gif, image/jpeg, image/png"
            multiple={false}
            type="select"
            name="thumbnail"
            showUploadList={false}
          >
            <Button>
              <UploadOutlined /> Click to upload
            </Button>
            {file && <p>{file.name}</p>}
          </Upload>
        </Form.Item>

        <Form.Item {...buttonItemLayout}>
          {!editMode ? (
            <Button
              onClick={onSubmit}
              type="primary"
              style={{
                background: "#ff0b53",
                borderColor: "#ff0b53",
                borderRadius: 5,
              }}
              disabled={articleCountes === 5}
            >
              Submit
            </Button>
          ) : (
            <Button
              onClick={onSubmit}
              type="primary"
              style={{
                background: "#ff0b53",
                borderColor: "#ff0b53",
                borderRadius: 5,
              }}
            >
              Update
            </Button>
          )}
          {editMode && (
            <Button
              style={{ marginLeft: 20 }}
              onClick={onCancelEditMode}
              type="ghost"
            >
              Cancel
            </Button>
          )}
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default LatestArticleForm;
